import { Links } from 'constants/link'
import { CustomLink } from 'components/ui'

import { Wrap, Container, List, ListItem, ListItemButton, Text, Badge } from './Style'

const Aside = () => {
  return (
    <Wrap>
      <Container>
        <List>
          <ListItem>
            <CustomLink title='_token-airdrop' url={Links.TOKEN} end={false} />
          </ListItem>
          <ListItem>
            <ListItemButton>
              <CustomLink title='_nft-airdrop' url={Links.NFT} end={false} />
              {/* eslint-disable react/jsx-no-comment-textnodes */}
              <Badge>/* soon */</Badge>
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemButton>
              <CustomLink title='_token-create' url={Links.CREATE} end={false} />
              {/* eslint-disable react/jsx-no-comment-textnodes */}
              <Badge>/* soon */</Badge>
            </ListItemButton>
          </ListItem>
        </List>
        <Text>The ultimate airdrop tool</Text>
      </Container>
    </Wrap>
  )
}

export { Aside }
